export default {"src":"/_next/static/media/DirectBank.67c7b9ca.svg","height":537,"width":2960,"blurWidth":0,"blurHeight":0};